import { useState } from "react";
import { apiPost } from "../lib/api";
import { COLORS } from "../lib/colors";

const TYPE_LABELS = {
  internship: "Internship",
  part_time: "Part-time job",
  graduate_program: "Graduate program",
  full_time: "Full-time position",
  project: "Project",
};

export default function PendingRecruiters({ pending, token, onRefresh }) {
  const [acting, setActing] = useState(null);

  // Only show recruiters who completed onboarding
  const filtered = (pending || []).filter(p => p.onboarding_completed);

  const handleAction = async (id, action) => {
    const endpoint = action === "approve"
      ? `/dashboard/approve_recruiter?recruiter_id=${id}`
      : `/dashboard/reject_recruiter?recruiter_id=${id}`;

    if (action === "reject" && !window.confirm("Reject this recruiter?")) return;

    setActing(id);
    try {
      await apiPost(endpoint, {}, token);
      onRefresh();
    } catch (err) {
      alert(`Failed to ${action}: ${err.message}`);
    } finally {
      setActing(null);
    }
  };

  return (
    <div>
      <h3 style={{ fontSize: 16, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>
        Pending Recruiter Approvals
      </h3>

      {filtered.length === 0 ? (
        <p style={{ fontSize: 13, color: COLORS.textMuted }}>No pending recruiter requests.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {filtered.map(p => {
            let engagementList = [];
            const raw = p.engagement_types;
            if (typeof raw === "string") {
              try { engagementList = JSON.parse(raw); } catch { engagementList = []; }
            } else if (Array.isArray(raw)) {
              engagementList = raw;
            }
            const engagementDisplay = engagementList.map(t => TYPE_LABELS[t] || t).join(", ") || "—";

            return (
              <div key={p.id} style={{
                backgroundColor: COLORS.surface,
                border: `1px solid ${COLORS.border}`,
                borderRadius: 10,
                padding: 16,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}>
                <div style={{ flex: 1 }}>
                  <p style={{ fontSize: 14, fontWeight: 600, color: COLORS.text, marginBottom: 4 }}>
                    {p.email || "Unknown"} — {p.company_name || "—"}
                  </p>
                  <p style={{ fontSize: 13, color: COLORS.textSecondary, marginBottom: 4 }}>
                    Looking for: {engagementDisplay} · Students: {p.student_count || "—"}
                  </p>
                  {p.role_description && (
                    <p style={{ fontSize: 12, color: COLORS.textMuted }}>{p.role_description}</p>
                  )}
                </div>
                <div style={{ display: "flex", gap: 8, marginLeft: 16, flexShrink: 0 }}>
                  <button
                    onClick={() => handleAction(p.id, "approve")}
                    disabled={acting === p.id}
                    style={{
                      padding: "6px 14px", borderRadius: 6, border: "none",
                      backgroundColor: COLORS.greenLight, color: COLORS.green,
                      fontSize: 13, fontWeight: 600, fontFamily: "inherit",
                      cursor: acting === p.id ? "wait" : "pointer",
                    }}
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleAction(p.id, "reject")}
                    disabled={acting === p.id}
                    style={{
                      padding: "6px 14px", borderRadius: 6, border: "none",
                      backgroundColor: COLORS.redLight, color: COLORS.red,
                      fontSize: 13, fontWeight: 600, fontFamily: "inherit",
                      cursor: acting === p.id ? "wait" : "pointer",
                    }}
                  >
                    Reject
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
